<template>
	<div class="d-flex flex-column">
		<header class="masthead mb-auto">
			<nav class="navbar navbar-expand-lg navbar-dark bg-no-trans">
				<div class="container-fluid">
					<a class="navbar-brand" href="/#/">
						<img src="../../assets/img/logo.png" alt="Logo" />
					</a>
					<ul class="navbar-nav ml-auto align-items-center navWithSearch">
						<li class="nav-item">
							<a class="nav-link" href="#" tabindex="-1" aria-disabled="true">
								<img
									v-bind:src="require(`@/assets/img/${this.n}.png`)"
									alt
									height="40px"
									width="40px"
									style="vertical-align: top"
								/>
							</a>
						</li>
						<li class="nav-item dropdown">
							<a
								class="nav-link dropdown-toggle"
								href="#"
								id="dropdown01"
								data-toggle="dropdown"
								aria-haspopup="true"
								aria-expanded="false"
							>
							</a>
							<div
								class="dropdown-menu dropdown-menu-right front"
								aria-labelledby="dropdown01"
							>
								<span class="dropdown-menu-arrow"></span>
								<a class="dropdown-item front" href="/#/profile2">
									Manage Profile</a
								>
								<a class="dropdown-item front" href="/#/account">Account</a>
								<a class="dropdown-item front" href="/#/mediaCenter"
									>Help Center</a
								>
								<a class="dropdown-item pointer front" @click="logout"
									>Sign Out</a
								>
							</div>
						</li>
					</ul>
				</div>
			</nav>
		</header>

		<section class="py-5 bg-grey200">
			<div class="container">
				<div class="row justify-content-center">
					<div class="col-md-6">
						<div class="card-body col-md-12">
							<ul class="list-group checkout-list-group">
								<li class="list-group-item">
									<p class="my-4 cardTitle">
										Set up your credit or debit card
									</p>
								</li>
								<li class="list-group-item">
									<div
										class="row d-flex  align-items-center justify-content-between"
									>
										<div class="col-auto">
											<span class="img"
												><img src="../../assets/img/mastercard.png"
											/></span>
											<span class="img"
												><img src="../../assets/img/visa.png"
											/></span>
											<span class="img"
												><img src="../../assets/img/Discover-card.png"
											/></span>
											<span class="img"
												><img src="../../assets/img/amex.png"
											/></span>
										</div>
									</div>
								</li>

								<li class="list-group-item">
									<form>
										<div class="form-group">
											<input
												type="text"
												class="form-control"
												placeholder="First Name"
												v-model="firstName"
											/>
										</div>
										<div class="form-group">
											<input
												type="text"
												class="form-control"
												placeholder="Last Name"
												v-model="lastName"
											/>
										</div>
										<div class="form-group">
											<div id="card-element" class="form-control"></div>
										</div>

										<div class="form-group">
											<input
												type="text"
												class="form-control"
												placeholder="Postal Code"
												v-model="postalCode"
											/>
											<img
												src="../../assets/img/information.svg"
												class="infoImg"
												alt=""
											/>
										</div>
									</form>
								</li>

								<li class="list-group-item">
									<div class="basicPlanWrapper">
										<p class="basicPlanPrice">${{ price }} {{ title }}</p>
										<p class="basicPlanText">{{ packagesTitle }}</p>
									</div>
								</li>

								<li class="list-group-item">
									<p>
										By checking the checkbox below, you agree to our Terms of
										Use, Privacy Statement, and that you are over 18. You may
										cancel at any time. Ibakatv will automatically continue your
										membership and charge the membership fee (currently $ {{ price }} ) to
										your payment method on a monthly basis until you cancel.
									</p>
									<div class="custom-control custom-checkbox mt-3">
										<input
											type="checkbox"
											v-model="checked"
											class="custom-control-input"
											id="customCheck1"
										/>
										<label class="custom-control-label" for="customCheck1"
											>I Agree</label
										>
									</div>
								</li>
								<li class="list-group-item">
									<div class="error" id="card-errors"></div>
									<div class="content">
										<button
											class="btn btn-block btn-primary"
											@click="setupPayment"
										>
											Continue
										</button>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
export default {
	name: "StripePaymentCopy",

	components: {},

	data() {
		return {
			payment: null,
			token: 0,
			cardElement: null,
			stripe: null,
			resToken: null,
			password: "",
			email: "",
			firstName: "",
			lastName: "",
			metaData: {},
			telephone: "",
			n: 0,
			postalCode: null,
			checked: false,
			currentSubs: null,
			currentpackages: null,
			packages: null,
			packagesTitle: "",
			price: "",
			title: "",
		};
	},

	computed: {},
	beforeCreate() {
		this.$store
			.dispatch("getStripeToken")
			.then((res) => {
				this.Publishable_Key = res.publishableKey;
				this.stripe = Stripe(this.Publishable_Key);
				var elements = this.stripe.elements();

				this.cardElement = elements.create("card");

				this.cardElement.mount("#card-element");
			})
			.catch((err) => {
			});
	},

	mounted() {},

	created() {
		this.$store.commit("showPopup", false);
		this.$store.commit("showdefaultFooter", true);
		this.$store.dispatch("account").then((res) => {
			this.$store.commit("setLoader", true);
			this.email = res.response.profile.username;
			var n = res.response.profile.metaData.image_id;
			if (n) {
				this.n = n;
			} else {
				this.n = this.n;
			}
			this.$store.commit("setLoader", false);
		});
		this.packages = this.$store.state.packages;
		this.packagesTitle = this.packages[2].title;
		this.currentSubs = this.getCurrentsubs();
		this.price = this.currentSubs.price;
		this.title = this.currentSubs.title;
	},
	methods: {
		logout() {
			this.$store.dispatch("logout").then((res) => {
				if (res == "true") {
					this.$router.push("/");
				}
			});
		},

		userNotLoggedin() {
			if (this.$store.state.user.logedin) {
				return true;
			} else {
				return false;
			}
		},
		gotoSingin() {
			this.$router.push("/login");
		},
		async createPayment() {
			self = this;
			await this.stripe
				.createPaymentMethod({
					type: "card",
					card: this.cardElement,
					billing_details: {
						address: {
							postal_code: this.postalCode,
						},
						name: this.firstName + " " + this.lastName,
					},
				})
				.then(function(result) {
					if (result.error) {
						var displayError = document.getElementById("card-errors");
						displayError.textContent = result.error.message;
					} else self.submit(result);
				})
				.catch((err) => {
				});
		},

		setupPayment(res) {
			this.createPayment();
		},
		submit(res) {
			var self = this;
			var dataToSend = {
				id: res.paymentMethod.id,
			};
			this.$store.commit("setLoader", true);
			this.$store
				.dispatch("stripePaymentProcess", dataToSend)
				.then((res) => {
					this.$store.commit("setLoader", false);
					if (res.status == 200) {
						self.$store.commit(
							"setNotification",
							" Payment Request sent Sucessfully!! "
						);
						this.$router.push(
							"/stripe-res/" +
								this.$route.params.sid +
								"/" +
								this.$route.params.pid
						);
					}
				})
				.catch((err) => {
					this.$store.commit("setLoader", false);
					self.$store.commit("setNotification", " Error while making payment ");
					this.$router.push("/account");
				});
		},
		getCurrentsubs() {
			var pid = this.$route.params.pid;
			var sid = this.$route.params.sid;
			let cp = this.packages.find((ele) => ele.id == pid);
			return cp.subscriptions.find((ele) => ele.id == sid);
		},
	},
};
</script>
<style scoped>
.error {
	color: red;
}
.text-center {
	align-items: center !important;
}
.my-input {
	padding: 10px;
	border: 1px solid rgb(48, 47, 47);
}

.content {
	display: flex;
	justify-content: center !important;
	margin-bottom: 30px;
}

.cardlabel {
	padding-bottom: 30px;
}
.py-5 {
	padding-top: 8rem !important;
	padding-bottom: 8rem !important;
	min-height: 80vh;
}
.pointer {
	cursor: pointer;
}
.card-body {
	cursor: pointer;
}
.py-5 {
	padding-top: 8rem !important;
	padding-bottom: 8rem !important;
	min-height: 100vh;
}
.form-control {
	background: #ffffff 0% 0% no-repeat padding-box;
	border: 1px solid #aaaaaa !important;
	border-radius: 4px;
	opacity: 1;
	width: 400px;
}
input::placeholder {
	text-align: left;
	letter-spacing: 0px;
	color: -internal-light-dark(black, white);
	text-rendering: auto;
	letter-spacing: normal;
	word-spacing: normal;
	text-transform: none;
	text-indent: 0px;
	text-shadow: none;
	display: inline-block;
	text-align: start;
	appearance: auto;
	margin: 0em;
	font: 400 13.3333px Arial;
}
/* .basicPlanWrapper {
	background: #ffffff 0% 0% no-repeat padding-box;
	opacity: 1;
} */
.basicPlanPrice {
	font: normal normal normal 14px/12px Averta-Semibold;
	letter-spacing: 0px;
	color: #181917;
	opacity: 0.85;
}
.basicPlanText {
	font: normal normal normal 11px/11px Averta-Regular;
	letter-spacing: 0px;
	color: #181917;
	opacity: 0.85;
}
.checkout-list-group .list-group-item:nth-child(even) {
	background-color: #ffffff;
}
.cardTitle {
	font: normal normal normal 18px Averta-Semibold !important;
	letter-spacing: 0px;
	color: #181917;
	opacity: 0.8;
}
.btn-block {
	width: 320px !important;
	height: 40px;
	background: #80b440 0% 0% no-repeat padding-box;
	opacity: 1;
}
.cvvImage {
	position: absolute;
	right: 128px !important;
	bottom: 90px !important;
}
.infoImg {
	position: absolute;
	right: 46px !important;
	bottom: 2px !important;
}
</style>
